import { Link } from '@tanstack/react-router';
import { Avatar, AvatarFallback, AvatarImage } from '@ui/avatar.tsx';
import { Button } from '@ui/button.tsx';
import { ArrowLeftIcon, CircleDot } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type ShopProfileHeaderProps = {
  shop: {
    displayName: string;
    logoUri?: string;
  };
  isActive: boolean;
};

export function ShopProfileHeader({ shop, isActive }: ShopProfileHeaderProps) {
  const { t } = useTranslation();
  const { displayName, logoUri } = shop;

  return (
    <div className="space-y-5">
      <div className="space-y-4">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex gap-4 items-center">
            <Avatar size="sm" className="border border-border">
              {logoUri ? <AvatarImage src={logoUri} alt={displayName} /> : null}
              <AvatarFallback text={displayName} initials={true} />
            </Avatar>

            <div className="space-y-2">
              <h1 className="text-4xl font-bold">{displayName}</h1>
              <div className="flex flex-wrap gap-2 items-center">
                <span
                  className={`inline-flex gap-1 items-center px-2 py-1 text-xs font-medium rounded-md ${
                    isActive ? 'text-emerald-600 bg-emerald-200' : 'text-red-600 bg-red-100'
                  }`}
                >
                  <CircleDot size={14} />
                  <span>
                    {isActive
                      ? t('admin.shops.update.form.status.enabled')
                      : t('admin.shops.update.form.status.disabled')}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-3 items-center">
          <Link
            to="/shops"
            className="inline-flex gap-2 items-center text-sm font-medium text-primary hover:underline"
          >
            <Button rounded="full">
              <ArrowLeftIcon />
              {t('common.back')}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
